<script lang="ts">
import vtkMouseCameraTrackballRollManipulator from '@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballRollManipulator';
import { computed, defineComponent, h } from 'vue';

import { ViewportToolMode } from '@/src/store/contours/types/tool-modes-type.js';
import { useViewportStateStore } from '@/src/store/contours/viewport-state-store';

import MouseManipulatorTool from './MouseManipulatorTool.vue';

export default defineComponent({
  props: {
    viewId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const viewportStateStore = useViewportStateStore();
    const toolOptions = computed(() => {
      const options = [] as any[];
      if (
        viewportStateStore.getToolMode(props.viewId) === ViewportToolMode.Rotate
      ) {
        options.push({ button: 1 });
        options.push({ button: 1, shift: true }); // works if Shift is still held after Shift+R
      }
      return options;
    });
    return () =>
      h(MouseManipulatorTool, {
        ...props,
        name: 'RotateTool',
        manipulatorClass: vtkMouseCameraTrackballRollManipulator,
        options: toolOptions.value,
      });
  },
});
</script>
